export const ROLE_USER = 'user'
export const ROLE_ASSISTANT = 'assistant'
